function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.4583 12.75H0C0 36.9102 17.9574 56.5 40.1042 56.5V84.625C40.1042 86.3438 41.3932 87.75 42.9688 87.75H48.6979C50.2734 87.75 51.5625 86.3438 51.5625 84.625V56.5C51.5625 32.3398 33.6051 12.75 11.4583 12.75ZM80.2083 0.25C65.1335 0.25 52.028 9.33203 45.1709 22.75C50.1302 28.6484 53.8005 35.8164 55.734 43.7656C75.9115 41.4805 91.6667 22.8867 91.6667 0.25H80.2083Z",
  fill: "#223355"
});

var SvgTierra = function SvgTierra(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 88,
    viewBox: "0 0 92 88",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTierra, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tierra.6adcdf96.svg";
export { ForwardRef as ReactComponent };